<template>
    <BreadCrumb PageTitle="Liste des BESC" />
    <ListeBesc/>
  </template>
  
  <script lang="ts">
  
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeBesc from "@/components/BESC/ListeBesc.vue";

    export default defineComponent({
      name: "ListeBescPage",
      components: {
        BreadCrumb,
        ListeBesc,
      },
    });
  </script>